/* =============================================================================
 *  Gazzaz — BOGOS Second-Product Popup   (theme: Be Yours / RoarTheme)
 *  الإصدار 4
 *  ---------------------------------------------------------------------------
 *  التغييرات عن v3:
 *    [إصلاح]  لوب لا نهائي عند فشل التحميل → عدّاد محاولات + إيقاف نهائي
 *    [إصلاح]  الترقيم بيقف عند صفحة 1 → fallback على عدد الكروت لكل عرض
 *    [إصلاح]  إعادة التقييم بعد طلب فاشل → فحص res.ok / xhr.status
 *    [إصلاح]  URL كـ Request/URL object كان بيتفوّت → String() coercion
 *    [إصلاح]  الـ popup كان بيقفل حتى لو الإضافة فشلت → بيستنى نتيجة فعلية
 *    [حذف]    productToOffers (كود ميت)
 *    [تحسين]  suppress بقى مربوط بنتيجة الطلب + مهلة أطول كحزام أمان
 *    [تحسين]  closePopup بقيت على العنصر نفسه بدل متغيّر عام بيتبدّل
 *    [واجهة]  skeleton أثناء التحميل، سطر "اخترت / متبقّي"، حالة خطأ فيها
 *             زرار إعادة محاولة، رأس ثابت، مقبض سحب على الموبايل،
 *             حبس الـ focus، احترام prefers-reduced-motion
 *
 *  التركيب:
 *    Assets → ارفع الملف. ثم في theme.liquid قبل </body>
 *    (وبعد سكريبتات BOGOS):
 *      <script src="{{ 'gazzaz-bogos-popup.js' | asset_url }}?v=4" defer></script>
 * ============================================================================= */

(function () {
  "use strict";

  /* ==========================================================================
   *  1) CONFIG
   * ========================================================================== */
  const OFFERS = [
    { id: "352582140042", x: 1, y: 1, handle: "buy-one-get-one-free-of-your-choice" } // 1+1 Perfume
  ];

  const CONFIG = {
    debug: false,
    gridSelector: "#product-grid",
    cardSelector: "li.flex-grid__item",
    maxPages: 20,
    maxRetries: 2,      // محاولات إعادة التحميل قبل الاستسلام
    suppressMs: 4000,   // حزام أمان فقط — الإلغاء الحقيقي بيحصل بنتيجة الطلب
    addTimeoutMs: 6000, // أقصى انتظار لنتيجة الإضافة قبل ما نقفل احتياطيًا
    text: {
      title: "أضف منتجك التالي",
      subtitle: "الأقل سعرًا بين منتجات العرض يُخصم بالكامل عند إتمام الطلب",
      loading: "جارٍ التحميل",
      empty: "لا توجد منتجات متاحة في هذه المجموعة حاليًا",
      allShown: "شاهدت كل المنتجات",
      error: "تعذّر تحميل المنتجات",
      retry: "إعادة المحاولة",
      addFailed: "تعذّرت الإضافة. جرّب منتجًا آخر",
      close: "إغلاق",
    },
  };

  function log(...a) { if (CONFIG.debug) console.log("[gz]", ...a); }

  /* ==========================================================================
   *  2) STATE
   * ========================================================================== */
  const idsCache = {};        // { offerId: Set(productIds) }
  const pageCache = {};       // { "handle:page": {cards, hasMore} }
  const pageSize = {};        // { offerId: عدد الكروت في الصفحة الأولى }
  const lastOpenedAt = {};    // { offerId: العدد اللي فتحنا عنده }
  let indexBuilt = false;
  let indexBuilding = null;
  let popupEl = null;
  let opening = false;
  let suppressReopen = false;
  let suppressTimer = null;
  let savedOverflow = "";
  let lastFocused = null;

  /* ==========================================================================
   *  3) الفهرس
   * ========================================================================== */
  async function fetchIds(offer) {
    if (idsCache[offer.id]) return idsCache[offer.id];
    const ids = new Set();
    try {
      let page = 1;
      while (page <= CONFIG.maxPages) {
        const res = await fetch(
          `/collections/${offer.handle}/products.json?limit=250&page=${page}`,
          { headers: { Accept: "application/json" } }
        );
        if (!res.ok) break;
        const batch = (await res.json()).products || [];
        batch.forEach((p) => ids.add(p.id));
        if (batch.length < 250) break;
        page++;
      }
    } catch (e) {
      log("فشل جلب ids لـ", offer.handle, e);
    }
    idsCache[offer.id] = ids;
    return ids;
  }

  function buildIndex() {
    if (indexBuilt) return Promise.resolve();
    if (indexBuilding) return indexBuilding;
    indexBuilding = Promise.all(OFFERS.map(fetchIds)).then(() => {
      indexBuilt = true;
    });
    return indexBuilding;
  }

  /* ==========================================================================
   *  4) السلة والاستحقاق
   * ========================================================================== */
  async function getCart() {
    const res = await fetch("/cart.js", { headers: { Accept: "application/json" } });
    if (!res.ok) throw new Error("cart " + res.status);
    return res.json();
  }

  function countInCart(cart, ids) {
    return cart.items
      .filter((it) => ids.has(it.product_id))
      .reduce((sum, it) => sum + it.quantity, 0);
  }

  async function evaluateAll(reason) {
    if (suppressReopen) { log("suppress نشط — تجاهل", reason); return; }
    if (popupEl || opening) return;

    await buildIndex();

    let cart;
    try { cart = await getCart(); }
    catch (e) { log("فشل قراءة السلة", e); return; }

    for (const offer of OFFERS) {
      const ids = idsCache[offer.id];
      if (!ids || ids.size === 0) continue;

      const count = countInCart(cart, ids);
      const round = offer.x + offer.y;
      log(offer.handle, "| x:", offer.x, "y:", offer.y, "| count:", count,
        "| آخر عتبة:", lastOpenedAt[offer.id] ?? "-");

      if (count === 0) { lastOpenedAt[offer.id] = -1; continue; }

      const isThreshold = count >= offer.x && (count - offer.x) % round === 0;
      if (!isThreshold) continue;
      if (lastOpenedAt[offer.id] === count) continue;

      lastOpenedAt[offer.id] = count;
      log("✅ مؤهّل →", offer.handle);
      openPopup(offer);
      return;
    }
  }

  /* ==========================================================================
   *  5) جلب كروت الثيم
   * ========================================================================== */
  async function fetchCards(offer, page) {
    const key = `${offer.handle}:${page}`;
    if (pageCache[key]) {
      return {
        cards: pageCache[key].cards.map((c) => c.cloneNode(true)),
        hasMore: pageCache[key].hasMore,
      };
    }

    const res = await fetch(`/collections/${offer.handle}?page=${page}`, {
      headers: { Accept: "text/html" },
    });
    if (!res.ok) throw new Error("collection page " + res.status);

    const doc = new DOMParser().parseFromString(await res.text(), "text/html");
    const grid = doc.querySelector(CONFIG.gridSelector);
    const cards = grid ? Array.from(grid.querySelectorAll(CONFIG.cardSelector)) : [];

    if (page === 1) pageSize[offer.id] = cards.length;

    // 1) رابط "التالي" لو الثيم بيعرض ترقيم كلاسيكي
    let hasMore = !!doc.querySelector(
      ".pagination__item--next a, a[rel='next'], link[rel='next'], " +
      ".pagination a[aria-label*='التالي'], .pagination a[aria-label*='Next']"
    );

    // 2) fallback: صفحة ممتلئة = غالبًا وراها صفحة
    //    (Be Yours ممكن يستخدم infinite scroll من غير روابط ترقيم)
    if (!hasMore && cards.length > 0 && cards.length >= (pageSize[offer.id] || 0)) {
      hasMore = true;
    }

    pageCache[key] = { cards, hasMore };
    return { cards: cards.map((c) => c.cloneNode(true)), hasMore };
  }

  /* ==========================================================================
   *  6) STYLES
   * ========================================================================== */
  function injectStyles() {
    if (document.getElementById("gazzaz-bogos-styles")) return;
    const style = document.createElement("style");
    style.id = "gazzaz-bogos-styles";
    style.textContent = `
      .gz-overlay{position:fixed;inset:0;z-index:99998;display:flex;
        background:rgba(0,0,0,.55);opacity:0;transition:opacity .28s ease;
        align-items:center;justify-content:center;padding:20px}
      .gz-overlay.gz-show{opacity:1}

      .gz-modal{background:rgb(var(--color-background,255,255,255));
        color:rgb(var(--color-foreground,20,20,20));
        font-family:var(--font-body-family,sans-serif);direction:rtl;
        width:100%;max-width:720px;max-height:88vh;
        display:flex;flex-direction:column;
        border-radius:14px;overflow:hidden;
        box-shadow:0 24px 60px -12px rgba(0,0,0,.35);
        transform:translateY(16px) scale(.985);
        transition:transform .28s cubic-bezier(.2,.8,.3,1)}
      .gz-overlay.gz-show .gz-modal{transform:none}

      /* ── الرأس ─────────────────────────────────────────── */
      .gz-head{flex:none;position:relative;padding:20px 52px 16px;text-align:center;
        border-bottom:1px solid rgba(var(--color-base-border,220,220,220),.5)}
      .gz-head h3{margin:0;font-family:var(--font-heading-family,inherit);
        font-size:1.65rem;font-weight:700;line-height:1.3;letter-spacing:-.015em}
      .gz-head p{margin:8px 0 0;font-size:1.05rem;font-weight:600;
        line-height:1.45;opacity:.75}

      .gz-close{position:absolute;top:14px;inset-inline-start:14px;
        width:34px;height:34px;display:grid;place-items:center;
        border:0;border-radius:50%;background:transparent;cursor:pointer;
        font-size:1.5rem;line-height:1;color:inherit;opacity:.5;
        transition:opacity .15s,background .15s}
      .gz-close:hover{opacity:1;background:rgba(var(--color-foreground,20,20,20),.06)}
      .gz-close:focus-visible{outline:2px solid rgb(var(--color-foreground,20,20,20));
        outline-offset:2px;opacity:1}

      /* مقبض السحب — موبايل فقط */
      .gz-handle{display:none}

      /* ── المحتوى ───────────────────────────────────────── */
      .gz-scroll{flex:1;overflow-y:auto;padding:18px 20px 8px;
        scroll-behavior:smooth;overscroll-behavior:contain;
        -webkit-overflow-scrolling:touch}
      .gz-grid{list-style:none;margin:0;padding:0;display:grid;gap:16px;
        grid-template-columns:repeat(3,1fr)}
      .gz-grid > li{margin:0;transition:transform .18s ease}
      @media (hover:hover){.gz-grid > li:hover{transform:translateY(-3px)}}

      /* نضمن ظهور زرار الإضافة جوّه الـ popup */
      .gz-grid .card-information__button,
      .gz-grid add-to-cart.button,
      .gz-grid add-to-cart{display:flex !important;visibility:visible !important;
        opacity:1 !important;pointer-events:auto !important}
      .gz-grid .badge--soldout{display:none !important}

      /* الكروت المنسوخة بتيجي ملفوفة في <use-animate> بتاع الثيم، وبيبدأ
         مخفي لحد ما IntersectionObserver يشوفه في الـ viewport الأساسي.
         جوّه الـ popup السكرول في حاوية خاصة، فالكروت ممكن تفضل شفافة.
         بنلغي أنيميشن الدخول هنا بس — باقي الموقع ما بيتأثرش. */
      .gz-grid use-animate,
      .gz-grid .card-wrapper,
      .gz-grid [data-animate]{
        opacity:1 !important;visibility:visible !important;
        transform:none !important;animation:none !important}

      /* ── هياكل التحميل ─────────────────────────────────── */
      .gz-skel{border-radius:8px;overflow:hidden}
      .gz-skel i{display:block;border-radius:6px;
        background:linear-gradient(90deg,
          rgba(var(--color-foreground,20,20,20),.05) 25%,
          rgba(var(--color-foreground,20,20,20),.10) 37%,
          rgba(var(--color-foreground,20,20,20),.05) 63%);
        background-size:400% 100%;animation:gz-shimmer 1.4s ease infinite}
      .gz-skel i.gz-skel-img{aspect-ratio:3/4;margin-bottom:10px;border-radius:8px}
      .gz-skel i.gz-skel-l1{height:11px;width:85%;margin-bottom:7px}
      .gz-skel i.gz-skel-l2{height:11px;width:45%}
      @keyframes gz-shimmer{0%{background-position:100% 0}100%{background-position:-100% 0}}

      /* ── الحالات ───────────────────────────────────────── */
      .gz-status{text-align:center;font-size:.82rem;opacity:.55;
        padding:16px 0 20px;min-height:1.2em}
      .gz-state{padding:44px 24px;text-align:center}
      .gz-state p{margin:0 0 16px;opacity:.65;font-size:.95rem}
      .gz-retry{border:1px solid rgba(var(--color-foreground,20,20,20),.25);
        background:transparent;color:inherit;font:inherit;font-size:.88rem;
        padding:9px 22px;border-radius:999px;cursor:pointer;
        transition:background .15s,border-color .15s}
      .gz-retry:hover{background:rgba(var(--color-foreground,20,20,20),.06);
        border-color:rgba(var(--color-foreground,20,20,20),.5)}
      .gz-retry:focus-visible{outline:2px solid rgb(var(--color-foreground,20,20,20));
        outline-offset:2px}

      .gz-toast{position:absolute;inset-inline:20px;bottom:18px;z-index:5;
        padding:11px 16px;border-radius:8px;font-size:.86rem;text-align:center;
        background:rgb(var(--color-foreground,20,20,20));
        color:rgb(var(--color-background,255,255,255));
        opacity:0;transform:translateY(8px);pointer-events:none;
        transition:opacity .2s,transform .2s}
      .gz-toast.gz-show{opacity:.95;transform:none}

      .gz-sentinel{height:1px}

      /* ── موبايل ────────────────────────────────────────── */
      @media (max-width:749px){
        .gz-overlay{align-items:flex-end;padding:0}
        .gz-modal{max-width:100%;max-height:92vh;
          border-radius:16px 16px 0 0;transform:translateY(100%) scale(1)}
        .gz-overlay.gz-show .gz-modal{transform:none}
        .gz-handle{display:block;width:36px;height:4px;border-radius:2px;
          margin:9px auto 0;flex:none;
          background:rgba(var(--color-foreground,20,20,20),.18)}
        .gz-head{padding:12px 48px 14px}
        .gz-head h3{font-size:1.32rem}
        .gz-head p{font-size:.95rem}
        .gz-close{top:8px}
        .gz-scroll{padding:14px 14px 8px}
        .gz-grid{grid-template-columns:repeat(2,1fr);gap:12px}
      }

      /* ── تقليل الحركة ──────────────────────────────────── */
      @media (prefers-reduced-motion:reduce){
        .gz-overlay,.gz-modal,.gz-grid > li,.gz-toast{transition:none}
        .gz-modal{transform:none}
        .gz-skel i{animation:none}
        .gz-scroll{scroll-behavior:auto}
      }
    `;
    document.head.appendChild(style);
  }

  /* ==========================================================================
   *  7) أدوات مساعدة
   * ========================================================================== */
  function armSuppress(ms) {
    suppressReopen = true;
    if (suppressTimer) clearTimeout(suppressTimer);
    suppressTimer = setTimeout(() => { suppressReopen = false; }, ms || CONFIG.suppressMs);
  }

  function releaseSuppress() {
    if (suppressTimer) clearTimeout(suppressTimer);
    suppressReopen = false;
  }

  function skeletonCards(n) {
    const frag = document.createDocumentFragment();
    for (let i = 0; i < n; i++) {
      const li = document.createElement("li");
      li.className = "gz-skel";
      li.setAttribute("aria-hidden", "true");
      li.innerHTML =
        '<i class="gz-skel-img"></i><i class="gz-skel-l1"></i><i class="gz-skel-l2"></i>';
      frag.appendChild(li);
    }
    return frag;
  }

  const FOCUSABLE =
    'a[href],button:not([disabled]),input:not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])';

  /* ==========================================================================
   *  8) POPUP
   * ========================================================================== */
  async function openPopup(offer) {
    if (popupEl || opening) return;
    opening = true;
    injectStyles();
    lastFocused = document.activeElement;

    const overlay = document.createElement("div");
    overlay.className = "gz-overlay";
    overlay.innerHTML = `
      <div class="gz-modal" role="dialog" aria-modal="true" aria-labelledby="gz-title">
        <div class="gz-handle"></div>
        <div class="gz-head">
          <h3 id="gz-title">${CONFIG.text.title}</h3>
          <p>${CONFIG.text.subtitle}</p>
          <button class="gz-close" type="button" aria-label="${CONFIG.text.close}">&times;</button>
        </div>
        <div class="gz-scroll">
          <ul class="gz-grid"></ul>
          <div class="gz-sentinel"></div>
          <p class="gz-status" role="status" aria-live="polite"></p>
        </div>
        <div class="gz-toast"></div>
      </div>`;

    const modal    = overlay.querySelector(".gz-modal");
    const scroll   = overlay.querySelector(".gz-scroll");
    const grid     = overlay.querySelector(".gz-grid");
    const sentinel = overlay.querySelector(".gz-sentinel");
    const status   = overlay.querySelector(".gz-status");
    const toast    = overlay.querySelector(".gz-toast");
    const closeBtn = overlay.querySelector(".gz-close");

    let page = 1;
    let loading = false;
    let done = false;
    let retries = 0;
    let observer = null;
    let skeleton = null;
    let closed = false;
    let awaitingAdd = null; // timer الاحتياطي بتاع الإضافة

    /* ---- تحميل الصفحات ---- */
    function showSkeleton() {
      if (skeleton) return;
      skeleton = document.createElement("div");
      skeleton.style.display = "contents";
      skeleton.appendChild(skeletonCards(page === 1 ? 6 : 3));
      grid.appendChild(skeleton);
    }
    function hideSkeleton() {
      if (skeleton) { skeleton.remove(); skeleton = null; }
    }

    function showState(message, withRetry) {
      hideSkeleton();
      status.textContent = "";
      const box = document.createElement("div");
      box.className = "gz-state";
      const p = document.createElement("p");
      p.textContent = message;
      box.appendChild(p);
      if (withRetry) {
        const btn = document.createElement("button");
        btn.className = "gz-retry";
        btn.type = "button";
        btn.textContent = CONFIG.text.retry;
        btn.addEventListener("click", () => {
          box.remove();
          retries = 0;
          done = false;
          loadPage();
        });
        box.appendChild(btn);
      }
      grid.insertAdjacentElement("afterend", box);
    }

    async function loadPage() {
      if (loading || done || closed) return;
      if (page > CONFIG.maxPages) { done = true; teardownObserver(); return; }

      loading = true;
      showSkeleton();
      status.textContent = "";

      try {
        const { cards, hasMore } = await fetchCards(offer, page);
        if (closed) return;
        hideSkeleton();

        if (cards.length === 0) {
          done = true;
          teardownObserver();
          if (page === 1) { grid.remove(); showState(CONFIG.text.empty, false); }
          else { status.textContent = CONFIG.text.allShown; }
          return;
        }

        retries = 0;
        cards.forEach((c) => grid.appendChild(c));
        page++;

        if (!hasMore) {
          done = true;
          teardownObserver();
          status.textContent = CONFIG.text.allShown;
        }
      } catch (e) {
        if (closed) return;
        hideSkeleton();
        log("خطأ تحميل الصفحة", e);
        // ← الإصلاح: نستسلم بعد عدد محدود من المحاولات بدل اللوب اللانهائي
        if (++retries >= CONFIG.maxRetries) {
          done = true;
          teardownObserver();
          showState(CONFIG.text.error, true);
        } else {
          status.textContent = CONFIG.text.error;
        }
      } finally {
        loading = false;
        if (!closed) maybeLoadMore();
      }
    }

    function maybeLoadMore() {
      if (done || loading || closed) return;
      if (scroll.scrollHeight <= scroll.clientHeight + 50) loadPage();
    }

    function teardownObserver() {
      if (observer) { observer.disconnect(); observer = null; }
    }

    observer = new IntersectionObserver(
      (entries) => { if (entries.some((en) => en.isIntersecting)) loadPage(); },
      { root: scroll, rootMargin: "320px" }
    );
    observer.observe(sentinel);

    /* ---- التعامل مع الإضافة ---- */
    function showToast(msg) {
      toast.textContent = msg;
      toast.classList.add("gz-show");
      setTimeout(() => toast.classList.remove("gz-show"), 3000);
    }

    // نتيجة أي كتابة للسلة بتوصلنا من الـ patch (القسم 9)
    function onCartWrite(e) {
      if (!e.detail || !/\/cart\/add/.test(e.detail.url)) return;
      if (awaitingAdd) { clearTimeout(awaitingAdd); awaitingAdd = null; }

      if (e.detail.ok) {
        // نجحت → نسيب suppress شغال شوية لحد ما BOGOS يخلص، وبعدين نقفل
        armSuppress(CONFIG.suppressMs);
        closePopup();
      } else {
        // ← الإصلاح: فشلت الإضافة → نفضل مفتوحين ونقول للعميل
        releaseSuppress();
        showToast(CONFIG.text.addFailed);
      }
    }
    document.addEventListener("gz:cart-write", onCartWrite);

    function onGridClick(e) {
      // منتج بخيارات → quick-view يشتغل عادي من غير تدخّل
      if (e.target.closest("quick-view-button, quick-view-drawer, .quick-view__summary")) return;
      if (!e.target.closest("add-to-cart, [data-variant-id]")) return;

      // بنمنع إعادة الفتح فورًا، والقرار النهائي بيتاخد في onCartWrite
      armSuppress(CONFIG.suppressMs);
      if (awaitingAdd) clearTimeout(awaitingAdd);
      awaitingAdd = setTimeout(() => {
        // ما وصلناش نتيجة (زرار مش بيعدّي على fetch/XHR؟) → نقفل احتياطيًا
        awaitingAdd = null;
        closePopup();
      }, CONFIG.addTimeoutMs);
    }
    grid.addEventListener("click", onGridClick);

    /* ---- إغلاق + حبس الـ focus ---- */
    function closePopup() {
      if (closed) return;
      closed = true;
      teardownObserver();
      if (awaitingAdd) { clearTimeout(awaitingAdd); awaitingAdd = null; }
      grid.removeEventListener("click", onGridClick);
      overlay.removeEventListener("click", onOverlayClick);
      document.removeEventListener("keydown", onKeydown);
      document.removeEventListener("gz:cart-write", onCartWrite);
      overlay.classList.remove("gz-show");
      document.body.style.overflow = savedOverflow;
      popupEl = null;
      setTimeout(() => overlay.remove(), 280);
      if (lastFocused && lastFocused.focus) { try { lastFocused.focus(); } catch (_) {} }
    }
    overlay.__gzClose = closePopup;

    function onOverlayClick(e) { if (e.target === overlay) closePopup(); }

    function onKeydown(e) {
      if (e.key === "Escape") { closePopup(); return; }
      if (e.key !== "Tab") return;
      // حبس الـ focus جوّه الـ modal
      const items = Array.from(modal.querySelectorAll(FOCUSABLE))
        .filter((el) => el.offsetParent !== null);
      if (items.length === 0) return;
      const first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    closeBtn.addEventListener("click", closePopup);
    overlay.addEventListener("click", onOverlayClick);
    document.addEventListener("keydown", onKeydown);

    savedOverflow = document.body.style.overflow;
    document.body.appendChild(overlay);
    popupEl = overlay;
    opening = false;
    requestAnimationFrame(() => overlay.classList.add("gz-show"));
    document.body.style.overflow = "hidden";
    closeBtn.focus();
    loadPage();
  }

  /* ==========================================================================
   *  9) اعتراض عمليات السلة — fetch + XHR
   * ========================================================================== */
  const CART_WRITE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;

  // حماية مزدوجة: لو السكريبت اتحمّل مرتين ما نعملش patch فوق patch
  if (window.__gzCartPatched) { log("الـ patch متركّب قبل كده — تخطّي"); return; }
  window.__gzCartPatched = true;

  function urlOf(input) {
    try {
      if (!input) return "";
      if (typeof input === "string") return input;
      return String(input.url || input.href || input);
    } catch (_) { return ""; }
  }

  function isCartWrite(url) {
    try { return !!url && CART_WRITE.test(url); } catch (_) { return false; }
  }

  function emitCartWrite(url, ok) {
    try {
      document.dispatchEvent(new CustomEvent("gz:cart-write", { detail: { url, ok } }));
    } catch (e) { log("فشل إرسال الحدث", e); }
    // نعيد التقييم فقط لو الطلب نجح
    if (ok) {
      Promise.resolve()
        .then(() => evaluateAll(url))
        .catch((e) => log("evaluateAll فشلت", e));
    }
  }

  /* ملاحظة: كل منطقنا هنا ملفوف في try/catch.
     السبب إننا بنـ patch الـ fetch/XHR العالمي — أي استثناء بيتسرّب مننا
     هيكسر إضافة السلة لكل التطبيقات (BOGOS، الثيم، …) مش سكريبتنا بس. */

  const _fetch = window.fetch;
  window.fetch = function (...args) {
    let url = "";
    try { url = urlOf(args[0]); } catch (_) {}

    const p = _fetch.apply(this, args); // الطلب الأصلي دايمًا بيمشي
    try {
      if (isCartWrite(url)) {
        p.then(
          (res) => { try { emitCartWrite(url, !!res && res.ok); } catch (_) {} },
          () => {}   // فشل الشبكة: مش بنعمل حاجة، والـ rejection بيكمّل للمنادي
        );
      }
    } catch (_) {}
    return p;
  };

  const _open = XMLHttpRequest.prototype.open;
  const _send = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    try { this._gzUrl = urlOf(url); } catch (_) { this._gzUrl = ""; }
    return _open.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function () {
    try {
      this.addEventListener("load", function () {
        try {
          if (isCartWrite(this._gzUrl)) {
            emitCartWrite(this._gzUrl, this.status >= 200 && this.status < 300);
          }
        } catch (_) {}
      });
    } catch (_) {}
    return _send.apply(this, arguments);
  };

  log("popup v4.4 initialized ✓");
})();